class FloatingVideo extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.initialX = 0;
    this.initialY = 0;
  }

  connectedCallback() {
    this.floatingVideo = this;
    this.closeButton = this.querySelector('.close-button');

    const closeVideo = () => {
      this.floatingVideo.classList.add('hidden');
    };

    this.closeButton.addEventListener('click', closeVideo);
    this.closeButton.addEventListener('touchend', closeVideo);

    this.floatingVideo.addEventListener('mousedown', (e) => this.startDrag(e));
    this.floatingVideo.addEventListener('touchstart', (e) => this.startDrag(e));

    document.addEventListener('mousemove', (e) => this.drag(e));
    document.addEventListener('touchmove', (e) => this.drag(e));

    document.addEventListener('mouseup', () => this.stopDrag());
    document.addEventListener('touchend', () => this.stopDrag());
  }

  startDrag(e) {
    this.isDragging = true;
    this.floatingVideo.style.cursor = 'grabbing';
    this.initialX = e.clientX || e.touches[0].clientX;
    this.initialY = e.clientY || e.touches[0].clientY;
    e.preventDefault();
  }

  drag(e) {
    if (this.isDragging) {
      const deltaX = (e.clientX || e.touches[0].clientX) - this.initialX;
      const deltaY = (e.clientY || e.touches[0].clientY) - this.initialY;

      this.floatingVideo.style.left = this.floatingVideo.offsetLeft + deltaX + 'px';
      this.floatingVideo.style.top = this.floatingVideo.offsetTop + deltaY + 'px';

      this.initialX = e.clientX || e.touches[0].clientX;
      this.initialY = e.clientY || e.touches[0].clientY;
    }
  }

  stopDrag() {
    this.isDragging = false;
    this.floatingVideo.style.cursor = 'grab';
  }
}

customElements.define('floating-video', FloatingVideo);